import { reactive } from 'vue';

// État global réactif pour l'assistant
const state = reactive({
  visible: false,
  title: 'Assistance BuddiBot',
  messages: [],
  options: [],
  closeOnClickOutside: true
});

// Service d'assistance Buddi
// Ajout d'un log pour vérifier que le service est bien créé
//console.log('Service BuddiAssistant initialisé');

const BuddiAssistant = {
  // Ouvre la modale d'assistance
  show(options = {}) {
    //console.log('BuddiAssistant.show() appelé', options);
    state.title = options.title || 'Assistance BuddiBot';
    state.messages = options.messages || [];
    state.options = options.options || [];
    state.closeOnClickOutside = options.closeOnClickOutside !== undefined ? options.closeOnClickOutside : true;
    state.visible = true;
    return this;
  },
  
  // Ferme la modale d'assistance
  hide() {
    state.visible = false;
    return this;
  },
  
  // Ajoute un message de Buddi
  addBotMessage(message) {
    state.messages.push(message);
    return this;
  },
  
  // Définit les options de réponse
  setOptions(options) {
    state.options = options;
    return this;
  },
  
  // Installation du plugin
  install(app) {
    //console.log('BuddiAssistant.install() appelé', app);
    // Rendre l'état accessible globalement
    app.config.globalProperties.$buddiAssistantState = state;
    
    // Rendre le service accessible globalement
    app.config.globalProperties.$buddiAssistant = BuddiAssistant;
    
    // Importer le composant BuddiChatModal
    const BuddiChatModal = app.component('BuddiChatModal');
    
    // Enregistrer le composant BuddiAssistantModal qui utilise BuddiChatModal
    app.component('BuddiAssistantModal', {
      template: `
        <BuddiChatModal 
          :visible="state.visible" 
          :title="state.title" 
          :initial-messages="state.messages.map(msg => ({ sender: 'bot', content: msg }))" 
          :initial-options="state.options"
          :close-on-click-outside="state.closeOnClickOutside"
          @close="onClose"
          @option-selected="onOptionSelected"
        />
      `,
      components: {
        BuddiChatModal
      },
      data() {
        return {
          state
        };
      },
      methods: {
        onClose() {
          BuddiAssistant.hide();
        },
        onOptionSelected(option) {
          // Vider les options actuelles
          state.options = [];
          
          // Exécuter le callback si présent
          if (option.callback) {
            option.callback();
          }
          
          // Ajouter les réponses
          if (option.responses && option.responses.length > 0) {
            option.responses.forEach(response => {
              state.messages.push(response);
            });
          }
          
          // Définir les nouvelles options
          if (option.nextOptions) {
            setTimeout(() => {
              state.options = option.nextOptions;
            }, 500);
          }
        }
      }
    });
  }
};

export default BuddiAssistant;
